import { useReframe } from 'nike-re-framejs';
import React, { ForwardedRef, forwardRef } from 'react';
import { isSubmitting } from 'nike-form-js';
import { Button } from '../button/Button';
import i18n from '../../common/i18n';

interface SubmitProps {
    form;
    disabled?: boolean;
    label: string;
    className?: string;
    dataAtid?: string;
    nuiWrapper?: boolean;
    primary?: boolean;
    large?: boolean;
}

const Submit = forwardRef(
    (
        {
            form,
            disabled = false,
            label,
            className,
            dataAtid,
            nuiWrapper = true,
            primary = true,
            large = true
        }: SubmitProps,
        ref: ForwardedRef<HTMLButtonElement>
    ) => {
        const { deref } = useReframe();
        const loading = deref(isSubmitting(form));

        const button = (
            <Button
                ref={ref}
                primary={primary}
                large={large}
                className={className}
                loading={loading}
                disabled={disabled}
                type="submit"
                onClick={() => console.log('submit', form)}
                label={label ? label : i18n('nui.button.register')}
                dataAtid={dataAtid}
            />
        );
        return nuiWrapper ? <div className="nui-input p-rel mb-20 flex flex-col">{button}</div> : button;
    }
);

export default Submit;
